import {ChangeDetectionStrategy, Component, OnDestroy} from '@angular/core';
import {AgRendererComponent} from 'ag-grid-angular';

@Component({
    standalone:false,
    selector: 'irb-global-cash-cell-renderer',
    template: `@if (params.value) {
  <span style='line-height:unset' (click)="click()"
    class="nav-link-text">
    <p-checkbox  (ngModelChange)="onCheckboxClick($event)" [(ngModel)]="checked" binary="true"></p-checkbox>
  </span>
}`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GlobalCashCellRendererComponent implements AgRendererComponent, OnDestroy {
    params: any;
    checked = true;
    constructor() {
        this.checked = true;
    }

    agInit(params: any) {
        this.params = params;
    }

    ngOnDestroy(): void {
    }

    refresh(): boolean {
        return false;
    }
    click() {
        if (typeof this.params.onClick !== "undefined") {
            this.params.onClick(this.params.data);
        }
    }
    onCheckboxClick(e:any) {
        this.checked = true;
        e.preventDefault();
    }
}
